package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.ActiveWhiteboard
import fr.manyverse.app.domain.repository.WhiteboardRepository

/**
 * Use case for getting the currently active whiteboard for a table.
 */
class GetActiveWhiteboardUseCase(
    private val whiteboardRepository: WhiteboardRepository
) {
    /**
     * Gets the currently active whiteboard for a table.
     *
     * @param tableId The game table ID
     * @return Result containing the active whiteboard or null if none exists
     */
    suspend operator fun invoke(
        tableId: String
    ): Result<ActiveWhiteboard?> {
        return whiteboardRepository.getActiveWhiteboard(
            tableId = tableId
        )
    }
}
